<template>
    <div class="users-style">

        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance Settings<span>
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Leave & Attendance Settings / Off-Day Template</span>
        </h4>
    <div class="ibox px-3 py-4 mt-4">

      <div class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0 pt-0 pb-0 roster-ibox">
          <h4 class="clearfix mb-0">
              <span class="float-left">Off-Day Template
                  <span class="title-sub-text"></span>
              </span>
              <span class="float-right"></span>
          </h4>
      </div>
      <b-overlay :show="loading">
      <div class="clearfix row py-2 mb-2">
        <div class="col-sm-6">
          <div class="custom-search w-100">
            <b-input-group class="mb-0">
              <b-input-group-prepend is-text>
                <b-icon icon="search"></b-icon>
              </b-input-group-prepend>
              <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
            </b-input-group>
          </div>
        </div>
        <div class="col-sm-6 float-right text-right px-3 d-flex flex-row justify-content-end">
          <b-button id="show-btn" class="" @click="openCreateModal">+ Add New Template</b-button>
        </div>
      </div>

      <div class="table-responsive employee-table-wrapper pb-0">
        <table class="employee-list-table table table-hover dataTable table-overflow table-sticky">
          <thead class="table-head">
          <tr>
            <th v-for="column in columns" :class="column.class">{{column.label}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="loading">
            <td colspan="8" class="text-center text-muted hover-bg table-row border-bottom mx-2">Loading…</td>
          </tr>
          <tr v-else v-for="(s, index) in filteredData" :key="s.id" class="hover-bg table-row border-bottom mx-2">
            <td>{{ index + 1 }}</td>
            <td>{{ s.name }}</td>
            <td>
              <span v-for="d in s.pattern" :key="d" size="md" class="mr-1 mb-1 px-2 py-1 rounded susd text_color"><strong>{{ dayLabels[d] }}</strong></span>
            </td>

            <td class="text-right">
              <div class="action">
                <b-button-toolbar class="float-right position-relative">
                  <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                  <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                    <b-button-group class="">
                      <b-button class="border-0 rounded py-0" variant="outline-secondary"  title="Edit Shift" @click="openEditModal(s)">
                        <b-icon icon="pencil-fill" aria-hidden="true" ></b-icon> Edit
                      </b-button>
                      <b-button class="border-0 rounded py-0" variant="outline-secondary" title="Delete Shift" @click="confirmDelete(s)">
                        <b-icon icon="trash" aria-hidden="true"></b-icon> Delete
                      </b-button>
                    </b-button-group>
                  </div>
                </b-button-toolbar>
              </div>
            </td>
          </tr>
          </tbody>
        </table>

        <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
        <div v-else class="mt-4">
          <ul class="pagination b-pagination float-left mb-0 mt-1">
            <li class="page-item disabled m-2">View</li>
            <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
            <li class="page-item disabled m-2">per page. Total {{templates.length}} records found.</li>
          </ul>
          <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>

        </div>
      </div>



    </b-overlay>
    </div>
    <!-- Create/Edit Modal -->
    <b-modal id="bv-modal-weekly-pattern-assign" :title="modalTitle" hide-footer @hidden="resetForm(1)" dialog-class="w-1000">
      <b-form @submit.stop.prevent="onSubmit" class="px-3">
        <b-form-group label="Pattern Name" label-for="pattern-name" class="required-field">
          <b-form-input id="pattern-name" name="pattern_name" v-model.trim="fdata.name" v-validate="{ required: true, min: 3, regex: /^[A-Za-z&()\/,_.\- ]+$/ }" data-vv-as="Pattern Name" :state="veeErrors.has('pattern_name') ? false : (fdata.name ? true : null)" placeholder="E.g., Weekend Fri-Sat" aria-describedby="pattern-name-feedback"/>
          <b-form-invalid-feedback id="pattern-name-feedback" v-if="veeErrors.has('pattern_name')">{{ veeErrors.first('pattern_name') }}</b-form-invalid-feedback>
        </b-form-group>


        <!-- <b-form-group class="w-100" label="Click on the day(s) to select/deselect weekly off days">
          <b-form-checkbox-group @change="error = ''" :readonly="fdata.id != null" :class="{'pointer-none':fdata.id != null}" class="w-100" v-model="fdata.pattern" :options="options" buttons button-variant="outline-secondary"/>
           <small class="d-block mt-2 text-danger" v-if="error != ''">{{ error }}</small>
          <small class="text-muted d-block mt-2" v-else>Selected: {{ fdata.pattern.map(d => dayLabels[d]).join(', ') || 'None' }}</small>
        </b-form-group> -->

        <div class="roster-leave-policy-modal">
            <b-form-group label="Click on the day(s) to select/deselect weekly off days" label-class="text-roster-green" class="leave-attendance-legends col-12 mt-4">
                <b-form-checkbox-group
                    class="leave-attendance-btns w-100"
                    v-model="fdata.pattern"
                    :readonly="fdata.id != null"
                    :class="{'pointer-none': fdata.id != null}"
                    buttons button-variant="outline-secondary"
                    @change="error = ''">
                    <b-form-checkbox
                        v-for="opt in options"
                        :key="opt.value"
                        :value="opt.value">
                        <span>{{ opt.text }}</span>
                    </b-form-checkbox>
                </b-form-checkbox-group>

                <small class="d-block mt-2 text-danger" v-if="error != ''">{{ error }}</small>
                <label class="d-block mt-2" v-else>
                    Selected: {{ fdata.pattern.map(d => dayLabels[d]).join(', ') || 'None' }}
                </label>
            </b-form-group>
        </div>

        <div class="text-center mt-4">
          <b-button type="submit" variant="primary" class="mr-2" :disabled="loading">{{ fdata.id ? 'Update' : 'Submit' }}</b-button>
          <b-button class="mr-2 custom-wizard-btn" @click="resetForm(1)">Reset</b-button>
          <b-button class="custom-wizard-btn" @click="$bvModal.hide('bv-modal-weekly-pattern-assign')">Cancel</b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- Delete confirm modal -->
    <b-modal id="bv-modal-delete-pattern" title="Delete Pattern" @ok="doDelete" ok-variant="primary" ok-title="Delete" cancel-title="Cancel">
      Are you sure you want to delete "<strong>{{ toDelete.name }}</strong>"?
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";

export default {
  computed: {
    filteredData()
    {
      let filtered_list = this.templates;
      if (this.search)
      {
        filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
      }
      return filtered_list;
    },
    paginatedData()
    {
      return this.paginate(this.filteredData, this.temp_length, this.pagination.currentPage);
    },
  },
  data() {
    return {
      search: '',
      loading: false,
      error: '',
      templates: [],
      dayLabels: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
      columns: [
        { key: 'index', label: 'SL' ,class:''},
        { key: 'name', label: 'Pattern Name' ,class:''},
        { key: 'pattern', label: 'Pattern' ,class:''},
        { key: 'actions', label: 'Actions' ,class:'text-right' },
      ],
      fdata: {
        id: null,
        name: '',
        pattern: [],
      },
      options: [
        { text: 'Sunday', value: '0' },
        { text: 'Monday', value: '1' },
        { text: 'Tuesday', value: '2' },
        { text: 'Wednesday', value: '3' },
        { text: 'Thursday', value: '4' },
        { text: 'Friday', value: '5' },
        { text: 'Saturday', value: '6' },
      ],
      toDelete: {
        name: '',
      },
      pagination: {currentPage: 1, pages:1},
      length_options:
          [
            { value: 20, text: "20" },
            { value: 50, text: "50" },
            { value: 100, text: "100" },
            { value: 500, text: "500" },
            { value: 1500, text: "1500" },
          ],
      temp_length: 20,
      modalTitle: 'Create Weekly Off-Day Pattern',
    };
  },

  methods: {
    moment,
    formatDate(iso) {
      if (!iso) return '';
      return String(iso).slice(0, 10);
    },

    toPatternArray(input) {
      if (Array.isArray(input)) {
        return input.map(d => String(d)).filter(d => ['0','1','2','3','4','5','6'].includes(d));
      }
      if (input == null) return [];
      if (typeof input == 'number') {
        const s = String(input);
        return ['0','1','2','3','4','5','6'].includes(s) ? [s] : [];
      }
      if (typeof input == 'string') {
        const trimmed = input.trim();
        // Try JSON first
        if ((trimmed.startsWith('[') && trimmed.endsWith(']')) || (trimmed.startsWith('"') && trimmed.endsWith('"'))) {
          try {
            const parsed = JSON.parse(trimmed);
            return this.toPatternArray(parsed);
          } catch (_) {
            // fallthrough to CSV
          }
        }
        // CSV like "5,6" or "5 , 6"
        const parts = trimmed.split(',').map(x => x.trim()).filter(Boolean);
        if (parts.length) {
          return parts.map(d => String(d)).filter(d => ['0','1','2','3','4','5','6'].includes(d));
        }
      }
      return [];
    },

    normalizeRow(row = {}) {
      const name = row.name;
      const patternRaw = row.pattern;
      const pattern = this.toPatternArray(patternRaw);

      return {
        id: row.id,
        name,
        pattern,
        created_at: row.created_at,
      };
    },

    fetchTemplates() {
      this.loading = true;
      axios.get(this.$api_url + '/leave-attendance/offday/template').then(response => {
        const items = response.data;
        this.templates = items.map(this.normalizeRow);
        this.loading = false;
      }).catch(e => this.serverError(e));
    },

    openCreateModal() {
      this.modalTitle = 'Create Weekly Off-Day Pattern';
      this.resetForm(1);
      this.$bvModal.show('bv-modal-weekly-pattern-assign');
    },

    openEditModal(item){
      this.fdata.id = item.id;
      this.fdata.name = item.name;
      console.log(item.pattern)
      this.fdata.pattern = [...item.pattern];
      this.modalTitle = 'Edit Weekly Off-Day Pattern';
      this.$bvModal.show('bv-modal-weekly-pattern-assign');
    },


    resetForm(flg = 0) {
      this.loading = false;
      this.error = '';
      if(flg == 1) this.fdata.id = null;
      this.fdata.name = '';
      this.fdata.pattern = [];
    },

    validateState(ref) {
      try {
        if (this.veeErrors && typeof this.veeErrors.has == 'function') {
          return this.veeErrors.has(ref) ? false : null;
        }
      } catch (_) {}
      return null;
    },

    onSubmit() {
      if (!this.fdata.pattern || this.fdata.pattern.length == 0) {
        this.error = 'Please select at least one weekly off day';
      }
      else {
        this.error = '';
      }
      this.$validator.validateAll().then(valid => {
        if (!valid || this.error != '') {
          return;
        }

        this.loading = true;
        const formData = new FormData();
        formData.append('name', this.fdata.name);
        formData.append('pattern', JSON.stringify(this.fdata.pattern.map(String)));
        formData.append('id', this.fdata.id);

        axios.post(this.$api_url + '/leave-attendance/offday/template', formData).then(response => {
          this.$bvToast.toast('Pattern saved', {
            variant: 'success',
            solid: true,
            title: 'Success'
          });

          this.$bvModal.hide('bv-modal-weekly-pattern-assign');
          this.fetchTemplates();
          this.loading = false;
        }).catch(e => {
          this.serverError(e);
          this.loading = false;
        });
      });
    },

    confirmDelete(item) {
      this.toDelete = item;
      this.$bvModal.show('bv-modal-delete-pattern');
    },

    doDelete() {
      axios.delete(this.$api_url + '/leave-attendance/offday/template/'+this.toDelete.id).then(response => {
        this.$bvToast.toast('Pattern deleted', { variant: 'success', solid: true, title: 'Success' });
        this.fetchTemplates();
      }).catch(e => {
        this.serverError(e);
      });
    },
  },

  mounted() {
    this.fetchTemplates();
  },
};
</script>
